import React, { useState, useMemo, useEffect } from "react"
import {
  Card,
  Col,
  Container,
  Button,
  Badge,
} from "reactstrap"
import Breadcrumbs2 from "components/Common/Breadcrumb2"
import TableContainer from "components/Common/TableContainer"
import Spinners from "components/Common/Spinner"
import { getGroupReport } from "helpers/api_helper"
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"

const draftDummyData = [
  {certName: "test1", currentState: "Алхам 2", created_date: "2024-12-31", modified_date: "2025-01-01"},
]

const CertificateIssues = () => {
  const navigate = useNavigate()

  const [certificateList, setCertificateList] = useState([])
  const [isLoading, setLoading] = useState(false)

  useEffect(() => {
    fetchPendingCertificates()
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "Сертификатын Нэр",
        accessor: "certName",
        Cell: ({ value }) => (
          <span className="text-wrap">{value}</span>
        ),
      },
      {
        Header: "Төлөв",
        accessor: "status",
        Cell: ({ value }) => (
          <Badge color={
            value === "new" ? "info" : 
            value === "valid" ?  "success" : "danger" 
          } className="px-3 py-2">
            {value === "new" ? "Шинэ" : 
            value === "valid" ? "Баталгаажсан" : "Цуцалсан"}
          </Badge>
        ),
      },
      {
        Header: "Гарын үсэг зурагч",
        accessor: "signers",
        Cell: ({ value, row }) => (
          <>
            <span className="text-wrap">{value}</span>
          </>
        ),
      },
      {
        Header: "Үүсгэсэн огноо",
        accessor: "created_date",
        Cell: ({ value }) => (
          <span className="text-wrap">{value}</span>
        ),
      },
      {
        Header: "Сурагчдын тоо",
        accessor: "student_count",
        Cell: ({ value }) => (
          <span className="text-wrap">{value}</span>
        ),
      },
      {
        Header: "Үйлдэл",
        accessor: "actions",
        Cell: ({ row }) => (
          <div className="d-flex gap-2">
            --
            {/* <Button
              color="primary"
              size="sm"
              outline
              onClick={() => {
                navigate('/created-certificates', {
                  state: { allSigners: row.original.allSigners, verifiedSigners: row.original.verifiedSigners }
                })
              }}
              className="d-flex align-items-center gap-1"
            >
              <span className="mdi mdi-eye" style={{fontSize: "14px"}}></span> Харах
            </Button> */}
          </div>
        ),
      },
    ],
    []
  )

  const fetchPendingCertificates = async () => {
    try {
        const response = await getGroupReport();
        if (response && response.data) {
            const formattedData = response.data.map(item => {
              return ({
                certName: item.groupName,
                status: item.signCount === item.requiredSignCount ? "valid" : "new",
                signers: `${item.signCount}/${item.requiredSignCount}`,
                student_count: item.certificateCount,
                created_date: new Date(item.createdAt).toLocaleDateString(),
                modified_date: '--',
              })
            });
            setCertificateList(formattedData);
        }
    } catch (error) {
        toast.error("Алдаа гарлаа. Та дахин оролдоно уу.");
    } finally {
        setLoading(false);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs2 
            title="Сертификат"
            breadcrumbItem="Байгууллагын сертификатууд"
            rightSideComponent={
              <Button color="primary" onClick={() => navigate('/add-certificate')}>
                + Шинэ сертификат үүсгэх
              </Button>
            }
          />
          <h6 className="card-title mb-4">Cертификат жагсаалт</h6>
          <Card style={{ minHeight: "200px" }} className="p-4 rounded-4">
            {isLoading ? (
              <Spinners setLoading={setLoading} />
            ) : certificateList?.length > 0 ? (
              <Col lg="12">
              <TableContainer 
                columns={columns}
                data={certificateList}
                isGlobalFilter={true}
                isShowingPageLength={true}
                customPageSize={10}
                tableClass="align-middle table-nowrap"
                theadClass="table-light"
                paginationDiv="col-12 col-sm-auto"
                pagination="pagination pagination-rounded justify-content-end mt-4"
              />
            </Col>
            ): (
              <div className="text-center p-4">
                <div className="avatar-sm mx-auto mb-4">
                  <span className="avatar-title rounded-circle bg-light">
                    <i className="bx bx-file text-primary font-size-24"></i>
                  </span>
                </div>
                <p className="text-muted">
                  Сертификат одоогоор үүсгэгдээгүй байна.
                </p>
              </div>
            )}
          </Card>
          
          <div style={{ width: "100%" }} className="my-4 border-1"></div>

          <h6 className="card-title mb-4">Ноорог</h6>
          <Card style={{ minHeight: "200px" }} className="p-4 rounded-4 d-flex justify-content-center align-items-center">
            <h5>Засвар хийгдэж байна</h5>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CertificateIssues